/**
 * 郵便番号から住所を自動入力する
 *
 * class="js-zip-auto" を持つ input に対して有効。
 * 7桁の数字が入力された時点で Zipcloud API を呼び出し、
 * 同じフォーム内の [name="your-prefecture"] と [name="your-city"] を自動入力する。
 *
 * Zipcloud API: https://zipcloud.ibsnet.co.jp
 */
const postalCodeLookup = () => {
  const zipInput = document.querySelector('.js-zip-auto');
  if (!zipInput) return;

  const form = zipInput.closest('form');
  if (!form) return;

  zipInput.addEventListener('input', async () => {
    const zip = zipInput.value.replace(/-/g, '').trim();
    if (zip.length !== 7 || !/^\d+$/.test(zip)) return;

    try {
      const res = await fetch(
        `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`,
      );
      const data = await res.json();

      if (data.status !== 200 || !data.results) return;

      const result = data.results[0];
      const prefSelect = form.querySelector('[name="your-prefecture"]');
      const cityInput = form.querySelector('[name="your-city"]');

      if (prefSelect) prefSelect.value = result.address1;
      if (cityInput) cityInput.value = result.address2 + result.address3;
    } catch {
      // 取得失敗時はサイレントに処理（ユーザーが手動入力できる）
    }
  });
};

export { postalCodeLookup };
